App.controller('setupAvailabilityCtrl', ($scope, $rootScope, $controller, $api, $timeout, Perm,
  InsurancePlan, AppointmentCategory,
  responseHelper, editableOptions, editableThemes, ngDialog, SweetAlert, FileUploader, authService, SERVER_BASE_URL) => {
  $controller('setupSharedCtrl', {
    $scope: $scope
  })

  editableOptions.theme = 'bs3'
  editableThemes.bs3.inputClass = 'input-sm'
  editableThemes.bs3.buttonsClass = 'btn-sm'
  editableThemes.bs3.submitTpl = '<button type="submit" class="btn btn-success"><span class="fa fa-check"></span></button>'
  editableThemes.bs3.cancelTpl = `<button type="button" class="btn btn-default" ng-click="$form.$cancel()"><span class="fa fa-times text-muted"></span></button>`

  $scope.members_status_active = 'Active'
  $scope.members_status_inactive = 'Inactive'
  $scope.members_statuses = [$scope.members_status_active, $scope.members_status_inactive]

  $scope.uploading_member_logo = {}

  $scope.appt_categories_loading = true

  Perm.perm_promise.then( () => {
    $scope.has_setup_permission = Perm.can_access_tab('setup')
    // Mirrors the RequiresAuthorization check on the React advanced availability page
    $scope.can_manage_availability = Perm.has_permission('online_booking:manage') ||
                                     Perm.has_permission('waitlist:manage')
    $scope.provider_meta_types = [
      "Dentist",
      "Doctor",
      "Hygienist",
      "Medical Assistant",
      "Nurse Practitioner",
      "Physician Assistant",
      "Provider"
    ]
    setLocation()
    setMemberLogoUploader()
    loadApptCategories()
  })

  $scope.$on('loc_change', () => {
    setLocation()
    setMemberLogoUploader()
    loadApptCategories()
  })

  setLocation = () => {
    $scope.location = $rootScope.location
    $scope.location_appt_types_map_by_operatory = $scope.location.appt_types_map_by_operatory
    if($scope.memberIsOperatory()) {
      $scope.member_type = 'Operatory'
      $scope.member_wording = 'operatory'
      $scope.members_wording = 'operatories'
    } else {
      $scope.member_type = 'User'
      $scope.member_wording = 'provider'
      $scope.members_wording = 'providers'
    }
    $scope.loaddocs()
  }

  $scope.loaddocs = () => {
    const locationId = $scope.location.id
    Perm.friends({ ids: true, no_self: true, location_id: locationId }).then(({ result }) => {
      if ($scope.location.id === locationId) {
        $scope.doctors = result
      }
    })
  }

  loadApptCategories = () => {
    $scope.appt_categories_loading = true
    appt_categories_req = AppointmentCategory.$search(locationParams())
    appt_categories_req.$finally(() => {
      $scope.appt_categories = appt_categories_req.$response.data.data
      $scope.appt_categories_loading = false
      loadMembers(onMembersLoadSuccess)
      setMemberLogoUploader()
    })
  }

  locationParams = (params = {}) => {
    if ($rootScope.institution.is_appt_categories_location_specific) {
      params['location_id'] = $rootScope.location.id
    }
    return params
  }

  onMembersLoadSuccess = () => {
    // get the whole set of the appt categories and mark the ones which are assigned to a member
    _.each($scope.members, (member) => {
      if(!member.display_name || !member.display_name.length){
        member.display_name = member.name
      }
      if($scope.memberIsOperatory()){
        if (member.bookable_online) {
          member.status = $scope.members_status_active
        } else {
          member.status = $scope.members_status_inactive
        }
      } else {
        if(member.provider_requestables && _.filter(member.provider_requestables, (pr) => { return pr.location_id == $scope.location.id }).length){
          member.status = $scope.members_status_active
        } else {
          member.status = $scope.members_status_inactive
        }
      }
    })
    setMemberLogoUploader()
    loadInsurances()
  }

  loadInsurances = () => {
    if (!$scope.memberIsProvider()) {
      $scope.insurance_loading = false
      return
    }

    $scope.insurance_loading = true
    provider_ids = _.map($scope.members, m => m.id)
    const search_resp = InsurancePlan.$search({ online_booking_customization: true, 'provider_id[]': provider_ids })
    return search_resp.$promise.then(data => {
      $scope.insurance_plans = search_resp.$response.data.data
      _.each($scope.members, (member) => {
        member.insurances = _.filter($scope.insurance_plans, (ip) => {
          return _.filter(ip.has_insurances, hi => hi.parent_type === 'User' && hi.parent_id === member.id).length > 0
        })
      })
      $scope.insurance_loading = false
    })
  }

  $scope.insurancesPopup = (provider) => {
    opts = {
      template: '/app/views/setup/tabs/insurances/popup.html',
      className: 'ne__modal ne__modal--setup',
      controller: 'setupInsurancesPopup',
      scope: $scope,
      data: { provider }
    }
    const dialog = ngDialog.open(opts)
    dialog.closePromise.then(d => {
      if (d.value.saved) {
        provider.insurances = d.value.insurance_plans
      }
    })
  }

  $scope.memberAppointmentTypesPopup = (member) => {
    opts = {
      template: '/app/views/setup/tabs/availability/appointment-types-popup.html',
      className: 'ne__modal ne__modal--setup',
      controller: 'setupMemberAppointmentTypesPopup',
      scope: $scope,
      data: { member }
    }
    const dialog = ngDialog.open(opts)
    dialog.closePromise.then(d => {
      if (d.value.saved) {
        member.appointment_types = d.value.appointment_types
      }
    })
  }

  // Update member (provider/operatory) name

  $scope.rememberMemberName = (member) => {
    member.initial_display_name = member.display_name
  }

  $scope.saveMemberName = (member) => {
    if(!member.display_name || !member.display_name.trim().length){
      member.display_name = member.initial_display_name
      return noMemberNameError()
    }

    saveOpts = { display_name: member.display_name }
    onSuccess = () => {
      member.initial_display_name = null
    }
    onError = () => {
      member.display_name = member.initial_display_name
    }
    saveMember(member, saveOpts, onSuccess, onError)
  }

  noMemberNameError = () => {
    SweetAlert.swal({
      title: '',
      text: `Please set the ${$scope.member_wording}'s name`,
      type: "error",
      confirmButtonColor: "#DCDEDF"
    })
  }

  // Upload member (provider/operatory) logo
  setMemberLogoUploader = () => {
    $scope.member_logo_uploader = setFileUploader()
    $scope.member_logo_uploader.onBeforeUploadItem = (item) => {
      $scope.uploading_member_logo[item.id] = true
    }
    $scope.member_logo_uploader.onSuccessItem = (item, response, status, headers) => {
      $scope.uploading_member_logo[item.id] = false
      member =_.find($scope.members, member => { return member.id === item.id })
      member.profile_url = response.data.profile_url
    }
    $scope.member_logo_uploader.onErrorItem = (item, response, status, headers) => {
      $scope.uploading_member_logo[item.id] = false
    }
    $scope.member_logo_uploader.onAfterAddingFile = (item) => {
      item.url = `${SERVER_BASE_URL}/${$scope.members_wording}/${item.id}/set_image?subdomain=${authService.getUserSubdomain()}`
      item.upload()
    }
  }

  setFileUploader = () => {
    return new FileUploader({
      headers: {
        'Authorization': authService.getUserAuthorizationHeader()
      },
      formData: [{}],
      autoUpload: false,
      removeAfterUpload: true,
      options: {
        autoUpload: false
      }
    })
  }

  // Update provider meta type
  $scope.saveProviderMetaType = (provider, provider_meta_type) => {
    provider.initial_meta_type = provider.meta_type
    provider.initial_utype = provider.utype
    provider.meta_type = 'Provider'
    provider.utype = (provider_meta_type == 'Provider' ? '' : provider_meta_type)

    saveOpts = { meta_type: provider.meta_type, utype: provider.utype }
    onSuccess = () => {
      provider.initial_meta_type = null
      provider.initial_utype = null
    }
    onError = () => {
      provider.meta_type = provider.initial_meta_type
      provider.utype = provider.initial_utype
    }
    saveMember(provider, saveOpts, onSuccess, onError)
  }

  $scope.memberHasDefaultType = (provider, metaType) => {
    if (provider.utype == null || provider.utype.trim() == '') {
      return provider.meta_type == metaType
    } else {
      return provider.utype == metaType
    }
  }

  $scope.memberHasCustomType = (provider) => {
    return provider.utype !== null &&
      provider.utype.trim() !== '' &&
      !$scope.provider_meta_types.includes(provider.utype)
  }

  // Update provider status
  $scope.saveMemberStatus = (member, member_status) => {
    member.initial_status = member.status
    member.status = member_status

    if($scope.memberIsOperatory()) {
      saveOpts = { 'bookable_online': member.status == $scope.members_status_active }
    } else {
      member.initial_provider_requestables = member.provider_requestables
      provider_requestables_opts = _.map(member.provider_requestables, (pr) => {
        return _.pick(pr, 'id', 'location_id', 'user_id')
      })
      if(!provider_requestables_opts.length){
        provider_requestables_opts = [{ 'location_id': $scope.location.id, 'user_id': member.id }]
      }
      if(member.status != $scope.members_status_active){
        _.each(provider_requestables_opts, (pr) => { pr['_destroy'] = true })
      }
      saveOpts = { 'provider_requestables_attributes': provider_requestables_opts }
    }

    onSuccess = (resp) => {
      member.initial_status = null
      if(!$scope.location.map_by_operatory || !$scope.location.appt_types_map_by_operatory) {
        member.provider_requestables = resp.data.data.provider_requestables
        member.initial_provider_requestables = member.provider_requestables
      }
    }
    onError = () => {
      member.status = member.initial_status
      if(!$scope.location.map_by_operatory || !$scope.location.appt_types_map_by_operatory) {
        member.provider_requestables = member.initial_provider_requestables
      }
    }
    saveMember(member, saveOpts, onSuccess, onError)
  }

  // Update provider common function
  saveMember = (member, saveOpts, onSuccess, onError, onSuccessAndError = false) => {
    opts = { location_id: $scope.location.id }
    opts[$scope.member_wording] = saveOpts
    $api('PUT', `/${$scope.members_wording}/${member.id}`, {}, opts).then((resp) => {
      if(onSuccessAndError){
        onSuccessAndError()
      }
      if(resp.data.code){
        onSuccess(resp)
      } else {
        onError() // restore prev state
      }
      responseHelperMsg(resp)
    })
  }

  responseHelperMsg = (resp) => {
    resp.$response = resp
    responseHelper.redirectOrToastOnResp(resp)
  }

  $scope.toSentence = (list, attr_name, max=2, emptyLabel='') => {
    if (!list || !list.length) {
      return emptyLabel
    }

    values = _.map(list, o => o[attr_name])
    if (values.length > max) {
      slice = values.slice(0, max)
      other = ` & ${values.length - max} more`
    } else {
      slice = values
      other = ''
    }

    return slice.join(', ') + other
  }


  // Toggle appt_types_map_by_operatory

  $scope.toggleMapApptTypesByOperatory = () => {
    $scope.location_appt_types_map_by_operatory = !$scope.location_appt_types_map_by_operatory
    if (!$scope.location.appt_types_map_by_operatory) {
      title = "Turn on"
    } else {
      title = "Turn off"
    }
    dialog = $rootScope.confirm_modal({
      title: `${title} map appointment types by operatory?`,
      text: "Are you sure you want to change your online booking format? This will require you to setup your online booking again.",
      custom_confirm: "Change online booking format"
    })

    $scope.map_appt_types_by_operatory_loading = true
    dialog.closePromise.then(data => {
      if(data.value == true){
        $api('PUT', `/locations/${$scope.location.id}`, {}, {
          appt_types_map_by_operatory: $scope.location_appt_types_map_by_operatory
        }).then((resp) => {
          $scope.location.appt_types_map_by_operatory = $scope.location_appt_types_map_by_operatory
          $rootScope.location.appt_types_map_by_operatory = $scope.location.appt_types_map_by_operatory
          responseHelper.redirectOrToastOnResp({ $response: resp }, 'app.setup.availability', null, {}, true)
        })
      } else {
        $scope.location_appt_types_map_by_operatory = !$scope.location_appt_types_map_by_operatory
      }
      $scope.map_appt_types_by_operatory_loading = false
    })
  }
})
